<template>
  <span>
    <component :is="'script'" type="application/ld+json" v-html="jsonData"></component>
  </span>
</template>

<script lang="ts">
import type { RegionDataType } from '@/schemas/regionDataSchema';
import { defineComponent, type PropType } from 'vue';
export default defineComponent({
  props: {
    regionData: {
      type: Object as PropType<RegionDataType>,
      required: true,
    },
  },
  computed: {
    jsonData() {
      return `{ "@context": "http://schema.org",
          "@type": "RealEstateAgent",
          "name": "${this.companyName}",
          "address": "${this.streetAddress} ${this.postalCode} ${this.postOffice}",
          "telephone":"${this.phoneNumber}",
          "email": "${this.email}",
          "logo":"https://op-koti.fi/assets/opkoti-logo-leftmargin-grey-whitebg.svg",
          "url":"${this.url}",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "${this.latitude}",
            "longitude": "${this.longitude}"
          }
        }`;
    },
    url() {
      return 'https://op-koti.fi' + this.$route.fullPath;
    },
    companyName() {
      return this.company?.name ?? '';
    },
    email() {
      return this.company?.contact?.email ?? '';
    },
    phoneNumber() {
      return this.company?.contact?.phone ?? '';
    },
    streetAddress() {
      return this.company?.contact?.streetAddress ?? '';
    },
    postOffice() {
      return this.company?.contact?.postOffice ?? '';
    },
    postalCode() {
      return this.company?.contact?.postalCode ?? '';
    },
    latitude() {
      return this.company?.contact?.coordinates?.latitude ?? '';
    },
    longitude() {
      return this.company?.contact?.coordinates?.longitude ?? '';
    },
    agentsData() {
      return this.regionData?.agents;
    },
    company() {
      const companyId = this.regionData?.companyRegion?.businessInfo?.companyId;
      if (companyId) {
        return this.regionData.companies.find((company) => company.id === companyId);
      } else if (this.regionData?.companies && this.regionData?.companies.length > 0) {
        return this.regionData?.companies[0];
      } else {
        return undefined;
      }
    },
  },
});
</script>
